import React from "react";
import { useTranslation } from "react-i18next";
import "./Header.css"; // Import the CSS file for styling

function Header() {
  const { i18n } = useTranslation();

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
  };

  return (
    <header className="header">
      {/* Left side: business logo */}
      <div className="header__logo">
        <a href="https://esrecader.com" target="_blank" rel="noopener noreferrer">
          <img
            src="/content/images/esrecader-logo.png"
            alt="Business Logo"
          />
        </a>
      </div>

      {/* Right side containers */}
      <div className="header__right">
        {/* Contact buttons */}
        <div className="header__contacts">
          <a
            href="https://wa.me/34612225736"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-button whatsapp"
          >
            WhatsApp <i className="fab fa-whatsapp"></i>
          </a>
          <a
            href="https://www.facebook.com/esrecader/"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-button facebook"
          >
            Facebook <i className="fab fa-facebook"></i>
          </a>
          <a
            href="https://www.instagram.com/esrecader/"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-button instagram"
          >
            Instagram <i className="fab fa-instagram"></i>
          </a>
        </div>

        {/* Language flags */}
        <div className="header__flags">
          <button onClick={() => changeLanguage("es")}>
            <img src="https://flagcdn.com/w20/es.png" alt="Spanish" />
          </button>
          <button onClick={() => changeLanguage("en")}>
            <img src="https://flagcdn.com/w20/gb.png" alt="English" />
          </button>
          <button onClick={() => changeLanguage("fr")}>
            <img src="https://flagcdn.com/w20/fr.png" alt="French" />
          </button>
        </div>
      </div>
    </header>
  );
}

export default Header;
